import { isServer } from "solid-js/web"

// refers to window.localStorage
export const hasLocalStorage = isServer ? false : !!window?.localStorage
